import { isJaguar } from "@/utility/UserUtils";
import React from "react";
import {
  Button,
} from "@mui/material"
import DefaultTooltip from "@/layouts/tooltips/DefaultTooltip"
import SettingsIcon from '@mui/icons-material/Settings';
import { hasClientAccess } from "@/utility/UserUtils";
const ManageInventoryButton = ({
  user,
  renter
}) => {
  if(isJaguar(user) || (renter && hasClientAccess(user, renter))) {
    return (
     <DefaultTooltip title="Manage Inventory">
        <Button
          href={renter && renter.id != 'all' ? `/inventory/${renter.id}/items` : "/management/items"}
          variant="contained"
          color="pink"
                    sx={{ minWidth: '0px', marginLeft: '10px' }} 
        >
          <SettingsIcon />
        </Button>
      </DefaultTooltip>
    )
  }
}

export default ManageInventoryButton